import { Transform } from "class-transformer";
import { stringToBoolean } from "../../types-transformers/boolean-transformers";

export class MessageFilter {
	@Transform(stringToBoolean)
	public markMessagesAsRead?: boolean;

	public from?: Date;
	public to?: Date;
	public limit?: number;
}
